import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["windowsContainer", "window", "addButtonContainer", "destroyField"];
  static outlets = ["select"];

  connect() {
    this.hideMarkedForDestructionWindows();
    this.updateAddButtonVisibility();
  }

  addWindow(event) {
    event.preventDefault();

    const template = document.getElementById("transfer-window-template").content.cloneNode(true);

    const newIndex = this.windowsContainerTarget.children.length;
    const newFields = template.querySelectorAll("[name]");

    newFields.forEach((field) => {
      field.name = field.name.replace("[]", `[${newIndex}]`);
    });

    // Update IDs for proper label association
    const elementsWithId = template.querySelectorAll("[id]");
    elementsWithId.forEach((element) => {
      element.id = element.id.replace("TEMPLATE_INDEX", newIndex);
    });

    const labels = template.querySelectorAll("label[for]");
    labels.forEach((label) => {
      label.setAttribute("for", label.getAttribute("for").replace("TEMPLATE_INDEX", newIndex));
    });

    this.windowsContainerTarget.appendChild(template);

    const availableDay = this.getFirstAvailableDay();
    if (availableDay !== null) {
      const dayInput = template.querySelector("input[name*='[day_of_week]']");
      if (dayInput) {
        dayInput.value = availableDay;
      }

      this.setDaySelectForNewWindow(newIndex, availableDay.toString());
    }
    this.updateAddButtonVisibility();
  }

  removeWindow(event) {
    event.preventDefault();

    const transferWindowElement = event.target.closest(
      "[data-support-agent--transfer-windows-target='window']"
    );

    const destroyField = transferWindowElement.querySelector(
      "[data-support-agent--transfer-windows-target='destroyField']"
    );
    const hasId = transferWindowElement.querySelector("input[name*='[id]']");

    if (hasId && hasId.value) {
      destroyField.value = "1";
      transferWindowElement.style.display = "none";
    } else {
      transferWindowElement.remove();
    }

    this.updateAddButtonVisibility();
  }

  updateAddButtonVisibility() {
    const visibleCount = this.windowTargets.filter(
      (window) => window.style.display !== "none"
    ).length;

    const addButton = this.addButtonContainerTarget.querySelector("button");
    if (addButton) {
      addButton.style.display = visibleCount >= 7 ? "none" : "inline-flex";
    }
  }

  hideMarkedForDestructionWindows() {
    // Hide windows that are marked for destruction on page load
    // This handles the case when form validation fails and page reloads
    this.windowTargets.forEach((window) => {
      const destroyField = window.querySelector(
        "[data-support-agent--transfer-windows-target='destroyField']"
      );
      if (destroyField && destroyField.value === "1") {
        window.style.display = "none";
      }
    });
  }

  selectOutletConnected(outlet) {
    const pendingInit = this.pendingInitializations;
    if (pendingInit && pendingInit.length > 0) {
      pendingInit.forEach(({ windowIndex, value }) => {
        const hiddenInput = outlet.element.querySelector(
          `input[name*="[${windowIndex}][day_of_week]"]`
        );
        if (hiddenInput !== null) {
          outlet.setSelectedValue(value);
          this.pendingInitializations = pendingInit.filter(
            (init) => !(init.windowIndex === windowIndex && init.value === value)
          );
        }
      });
    }
  }

  setDaySelectForNewWindow(windowIndex, value) {
    // Try to find an existing outlet for this window
    const daySelectOutlet = this.selectOutlets.find((outlet) => {
      const hiddenInput = outlet.element.querySelector(
        `input[name*="[${windowIndex}][day_of_week]"]`
      );
      return hiddenInput !== null;
    });

    if (daySelectOutlet) {
      daySelectOutlet.setSelectedValue(value);
    } else {
      if (!this.pendingInitializations) {
        this.pendingInitializations = [];
      }
      this.pendingInitializations.push({ windowIndex, value });
    }
  }

  getFirstAvailableDay() {
    const usedDays = new Set();

    // Get all visible windows and collect their days
    const visibleWindows = this.windowTargets.filter((window) => window.style.display !== "none");

    visibleWindows.forEach((window) => {
      const dayInput = window.querySelector("input[name*='[day_of_week]']");
      if (dayInput && dayInput.value) {
        usedDays.add(parseInt(dayInput.value));
      }
    });

    for (let day = 0; day < 7; day++) {
      if (!usedDays.has(day)) {
        return day;
      }
    }

    return null;
  }
}
